import { giftCodeExperienceURL } from 'endpoints';
import fetch from '../utils/fetch';
import { startLoading, endLoading, setAlertMessage } from './app-dux';

/*******************************************************************************
 * Initial state
 */
const initialState = {
	done: false,
	products: [],
	viewProductsListPage: false
};

/*******************************************************************************
 * Non-async action types
 */
export const SET_STATE = 'SET_STATE';
export const SET_DONE = 'SET_DONE';
export const LOAD_PRODUCTS = 'LOAD_PRODUCTS';

/*******************************************************************************
 * Reducer
 */
export default function ProductsPage( state = initialState, action ) {
	switch ( action.type ) {
		case SET_STATE:
			return {
				...state,
				...action.state
			};

		case LOAD_PRODUCTS:
			return {
				...state,
				products: action.data.products
			};

		case SET_DONE:
			return {
				...state,
				done: action.done
			};

		default:
			return state;
	}
}

/*******************************************************************************
 * Action creators
 */

export function fetchProducts( browseCode ) {
	return ( dispatch, getState ) => {
		const state = getState();
		const locale = sessionStorage.getItem( 'userSessionLocale' ) || state.app.locale || state.company.defaultLocaleCode || 'en-US';
		dispatch( startLoading() );

		return fetch( `${ giftCodeExperienceURL }/getProducts/${ browseCode }`, {
			method: 'POST',
			headers: { 'content-type': 'application/json' },
			body: JSON.stringify(
				{
					locale: locale
				}
			)
		} ).then( ( res ) => {
			if ( res.ok ) {
				res.json().then( ( response ) => {
					dispatch( setDone( true ) );
					if ( response.errors && response.errors.length > 0 ) {
						let errorMessage = response.errors[ 0 ].message;
						if ( !errorMessage.includes( 'giftCode.error' ) ) {
							errorMessage = 'giftCode.error.unknownError';
						}
						dispatch( setAlertMessage( errorMessage, 'DANGER' ) );
					} else {
						dispatch( loadProducts( response.data ) );
						dispatch( setState( { viewProductsListPage: true } ) );
					}
					dispatch( endLoading() );
				} );
				return res;
			} else {
				res.json().then( ( response ) => {
					let errorMessage = 'giftCode.error.unknownError';
					if ( response.errors && response.errors.length > 0 ) {
						errorMessage = response.errors[ 0 ].message;
						if ( !errorMessage.includes( 'giftCode.error' ) ) {
							errorMessage = 'giftCode.error.unknownError';
						}
					}
					dispatch( setAlertMessage( errorMessage, 'DANGER' ) );
					dispatch( endLoading() );
					console.error( errorMessage );
				} );
			}
		} ).catch( ( err )=> {
			dispatch( setAlertMessage( 'giftCode.error.unknownError', 'DANGER' ) );
			dispatch( endLoading() );
			console.error( err );
		} );
	};
}

function setState( state ) {
	return {
		type: SET_STATE,
		state
	};
}

export function setDone( done ) {
	return {
		type: SET_DONE,
		done
	};
}

export function loadProducts( data ) {
	return {
		type: LOAD_PRODUCTS,
		data
	};
}